@let reportData = report();

<div class="alert-container px-4 mt-4 flex flex-col gap-2">
  <app-theft-notice-alert></app-theft-notice-alert>

  @if (loadErrorMessage(); as message) {
    <app-pan-inline-alert type="danger">{{ message }}</app-pan-inline-alert>
  } @else if (reportData && !reportData.is_shared) {
    <app-pan-inline-alert type="warning">
      This report hasn't been shared. Sharing is required for other users to view this report.
    </app-pan-inline-alert>
  }
</div>

@if (loadingData()) {
  <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> &nbsp;Loading... </app-pan-blank-slate>
}

@if (reportData) {
  <app-pan-card
    data-testid="user-report-card"
    class="block mb-20"
    [isPageContainer]="true"
    pageContainerSize="xl"
    [header]="reportData.title"
    [subheader]="subtitle()"
  >
    <div rightActions>
      <app-share-email-modal
        modalTitle="Share Link to Report"
        [locationIds]="reportLocationIds()"
        [disabled]="isSharing()"
        [isSharing]="isSharing()"
        (share)="share($event)"
        searchType="locations"
      ></app-share-email-modal>
    </div>

    <div class="flex flex-col gap-2">
      @for (branch of reportCases(); track $index) {
        <app-pan-section-header [title]="branch.branchName"></app-pan-section-header>

        <ag-grid-angular [rowData]="branch.cases" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>
      }
    </div>
  </app-pan-card>
}

<app-footer [public]="true" [copyright]="true"></app-footer>
